import React from 'react';
import { motion } from "framer-motion";
import RamIcon from './RamSVGIcon';
import "./Ram.scss";

type Props = {
  transformValue: number;
  parentWidth: number;
}

function Ram({transformValue, parentWidth}: Props) {

  function pickHex(weight) {
    var w1 = weight;
    var w2 = 1 - w1;
    var rgb = [Math.round(255 * w1 + 255 * w2),
        Math.round(0 * w1 + 255 * w2),
        Math.round(0 * w1 + 0 * w2)];
    return rgb;
  }

  const firstColor = pickHex(transformValue * 0.01)[0]
  const secondColor = pickHex(transformValue * 0.01)[1]
  const thirdColor = pickHex(transformValue * 0.01)[2]

  return (
    <motion.div
      animate={{
        x: (parentWidth - 35) * transformValue * 0.01,
      }}
      transition={{
        duration: 1.5,
      }}
    >
      <RamIcon fill={`rgb(${firstColor}, ${secondColor}, ${thirdColor})`} />
    </motion.div>
  )
}

export default Ram;
